import { render, staticRenderFns } from "./ResultadoAvalicaoAcademy.vue?vue&type=template&id=24278115&scoped=true&"
import script from "./ResultadoAvalicaoAcademy.vue?vue&type=script&lang=js&"
export * from "./ResultadoAvalicaoAcademy.vue?vue&type=script&lang=js&"
import style0 from "./ResultadoAvalicaoAcademy.vue?vue&type=style&index=0&id=24278115&scoped=true&lang=css&"
import style1 from "./ResultadoAvalicaoAcademy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24278115",
  null
  
)

export default component.exports